module.exports = __webpack_public_path__ + "img/loading.80be884e.gif";